// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeTokenApi = class EdgeTokenApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
    }
    /**
     *
     * @param iCreateSessionRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationGuest(iCreateSessionRequest, xProgramId) {
        const _url_ = '/edge/token/v1/Authentication/guest';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iCreateSessionRequest' is not null or undefined
        if (iCreateSessionRequest === null || iCreateSessionRequest === undefined) {
            throw new Error('Required parameter iCreateSessionRequest was null or undefined when calling authenticationGuest.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iCreateSessionRequest, "ICreateSessionRequest"),
        };
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IAuthenticationResponseModel");
        }
        return response;
    }
    /**
     *
     * @param iExistingUserRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationIsExistingUser(iExistingUserRequest, xProgramId) {
        const _url_ = '/edge/token/v1/Authentication/isExistingUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iExistingUserRequest' is not null or undefined
        if (iExistingUserRequest === null || iExistingUserRequest === undefined) {
            throw new Error('Required parameter iExistingUserRequest was null or undefined when calling authenticationIsExistingUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iExistingUserRequest, "IExistingUserRequest"),
        };
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationIsExistingUserResponse");
        }
        return response;
    }
    /**
     *
     * @param iAuthenticateAndCreateSessionRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationLogin(iAuthenticateAndCreateSessionRequest, xProgramId) {
        const _url_ = '/edge/token/v1/Authentication/login';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iAuthenticateAndCreateSessionRequest' is not null or undefined
        if (iAuthenticateAndCreateSessionRequest === null || iAuthenticateAndCreateSessionRequest === undefined) {
            throw new Error('Required parameter iAuthenticateAndCreateSessionRequest was null or undefined when calling authenticationLogin.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iAuthenticateAndCreateSessionRequest, "IAuthenticateAndCreateSessionRequest"),
        };
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IAuthenticationResponseModel");
        }
        return response;
    }
    /**
     *
     * @param iTouchSessionRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationTouch(iTouchSessionRequest, xProgramId) {
        const _url_ = '/edge/token/v1/Authentication/touch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'iTouchSessionRequest' is not null or undefined
        if (iTouchSessionRequest === null || iTouchSessionRequest === undefined) {
            throw new Error('Required parameter iTouchSessionRequest was null or undefined when calling authenticationTouch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iTouchSessionRequest, "ITouchSessionRequest"),
        };
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationTouchResponse");
        }
        return response;
    }
};
EdgeTokenApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeTokenApi);
export { EdgeTokenApi };
//# sourceMappingURL=edgeTokenApi.js.map